<script>
  export default {
    name: "WidgetSingleImageLinkOption",
    props: {
      /** An array of image blocks with links */
      blocks: {
        type: Array,
        default: null
      }
    }
  }
</script>

<template>
  <div class="callout--single-image">
    <div v-for="(block, index) in blocks" :key="index">
      <a v-if="block.url" :href="block.url" class="js-lightbox--image">
        <img :src="block.image" />
      </a>
      <img v-else :src="block.image" />
    </div>
  </div>
</template>
